import {collaborator} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadCollaborator(additional?: string) {
  return useLoad(collaborator, 'employee_Nr', {additional});
}
export default useLoadCollaborator;
